export default function guard(to, from, next) {
    const token = localStorage.getItem('token');
    if(token) {
        next();
    } 
    else {
        next('/admin-login');
    }
}